export default {"src":"/_next/static/media/icon-warn-toast.3d472b0a.svg","height":14,"width":14};